export const quotesArray = [
	{
		code:
			"reduce(lambda x, y: x * y, range(1, n+1)) [line.strip() for line in open(filename)] reduce(lambda x, y: x * y, range(1, n+1))",
	},
	{
		code: 
			"int main(){ for(int i=0; i< length; i++){ int a  = 0; *p = & a"
	},
	{
		code: 
			"const shuffleArray = (arr) => arr.sort(() => Math.random() - 0.5); navigator.clipboard?.writeText && navigator.clipboard.writeText(text); const getUnique = (arr) => [...new Set(arr)];"
	},
	{
		code: 
			"go list -u -m $(go list -m -f '{{.Indirect}} {{.}}' all | grep '^false' | cut -d ' ' -f2) | grep '['"
	}


]
//  We actually dont want a random value, we should be able to select which "prboblem we want"

export const random = array => array[Math.floor(Math.random() * array.length)]



export const allowedKeys = [
	'q',
	'w',
	'e',
	'r',
	't',
	'y',
	'u',
	'i',
	'o',
	'p',
	'a',
	's',
	'd',
	'f',
	'g',
	'h',
	'j',
	'k',
	'l',
	'z',
	'x',
	'c',
	'v',
	'b',
	'n',
	'm',
	'Q',
	'W',
	'E',
	'R',
	'T',
	'Y',
	'U',
	'I',
	'O',
	'P',
	'A',
	'S',
	'D',
	'F',
	'G',
	'H',
	'J',
	'K',
	'L',
	'Z',
	'X',
	'C',
	'V',
	'B',
	'N',
	'M',
	';',
	"'",
	',',
	'.',
	':',
	"[",
	"]",
	"=",
	">",
	"&",
	"|",
]